import * as alight from 'alight';
import template from './menu.pug';

export function Item(scope, el, expression, env) {
    var l = env.changeDetector.locals;
    var item = l.subitem || l.item;

    el.addEventListener('click', e => {
        this.onClick(item);
        e.stopPropagation();
    });
}

export function Tooltip(scope, el, expression, env) {
    var l = env.changeDetector.locals;
    var item = l.item;
	
	var objItem = scope.contextMenu.getItem(item);
	// console.log("test");
	// console.log(el);
	// console.log(env);
	// console.log(expression);
	
	el.innerHTML = objItem.tooltip;

    el.addEventListener('click', e => {
        this.onClick(item);
        e.stopPropagation();
    });
}

export class ContextMenu {

    constructor(params) {
        this.visible = false;
        this.x = 0;
        this.y = 0;
		this.params = params;
        this.default = {
            searchBar: false,
            onClick() { throw new TypeError('onClick should be overrided');}
        };

        this.bindTemplate();
    }

    bindTemplate() {
        this.el = document.createElement('div');
        this.el.setAttribute('tabindex', 1);
        this.el.innerHTML = this.params.template || template();

        const al = alight.makeInstance();

        al.directives.al.item = Item.bind(this);
		al.directives.al.tooltip = Tooltip.bind(this);
        this.$cd = al(this.el, { contextMenu: this });
    }

	searchItems(filter) {
		// var regex = new RegExp(filter, 'i');
		
		var keywordsArr = [];
		
		if(filter != undefined && filter != ''){
			keywordsArr = filter.toLowerCase().split(' ');
		}
		
		var filteredArr = [];
		
		Object.keys(this.items).forEach(function(item){
			// console.log(item);
			var isValid = true;
			keywordsArr.forEach(function(keyword){
				if(!item.toLowerCase().includes(keyword)){
					isValid = false;
				}
			});
			
			if(isValid){
				filteredArr.push(item);
			}
		});
		// return Object.keys(this.items).filter(key => {
		  // return regex.test(key);
		// });
		return filteredArr;
  }
	
	getItem(item){
		return this.items[item];
	}

    haveSubitems(item) {
        return item.constructor === Object;
    }

    isVisible() {
        return this.visible;
    }

    show(x, y, items = null, searchBar = null, onClick = null) {
        if (this.disabled) return;
        
        this.visible = true;
        this.items = items || this.default.items;
        this.searchBar = searchBar || this.default.searchBar;
        this.onClick = onClick || this.default.onClick;
        this.x = x;
        this.y = y;
        this.$cd.scan();
		
		this.el.querySelector('input').focus();
		// console.log(this.el);
    }

    hide() {
        this.visible = false;
        this.$cd.scan();
    }
}